module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_j_albino.df7e690e.png";